import { NgModule } from 'ng-metadata/core';
import {SourceRecordService} from './sourceRecord.service';
import {PrmSourceRecord} from './sourceRecord.directive';

@NgModule({
    declarations: [
        PrmSourceRecord
    ],
    providers: [
        SourceRecordService
    ],
    imports:[

    ]
})
export class SourceRecordModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/sourceRecord/sourceRecord.module.ts